export default __webpack_public_path__ + "static/media/landin-blockimg15.e71b6cbc.png";